// ABOUTME: The one place the availability module picks its API: pro-core's (./api), or the mock layer's in a dev build
// ABOUTME: that names this module in VITE_MOCK_API. The queries call through here and never know which it is.
import { mockRegistry } from 'mocks/registry';
import * as api from './api';

export const availabilityApi: typeof api =
  mockRegistry.apis.availability ?? api;
